import {LokalisierungsProvider} from "../../global/Localizer";
import {afterBrowserRepaintDo, existsLastLoggedInUserCookie, noop} from "../../global/globalUtils";
import {EventListener, EventVerteiler} from "../../global/eventVerteiler";
import {PopupButton, POPUPS, PopupTools} from "../../global/popupTools";
import {HTMLPrinter} from "../../global/htmlprinter";
import {HINTBOXEVENTNAMES} from "../../global/GlobalEventnames";
import {CONSTANTS} from "../meta_data";
import {RahmenTabsStaticFunctions} from "./rahmenTabsStaticFunctions";
import {NthIterationExecutor} from "../../global/nthIterationExecutor";
import globalsObject, {handleError} from "../globalsObject";
import {DIALOGDEFINITION} from "../../global/dialogDefinitions";
import {Produktwechsel} from "../../../konfi_mobile/src/components/productChange/Produktwechsel";

export class RahmenTabsDialogDisplayer extends EventListener {
    private localizer: LokalisierungsProvider;
    private notLoggedInWarner: NthIterationExecutor;


    constructor(localizer: LokalisierungsProvider) {
        super();
        this.localizer = localizer;
        const $this = this;
        this.notLoggedInWarner = new NthIterationExecutor(function (dialog) {
            afterBrowserRepaintDo(() => {
                    EventVerteiler.broadcastBlockRequest("notLoggedInWarning");
                    if (existsLastLoggedInUserCookie()) {
                        dialog = "warningNotLoggedInReLogin";
                    }
                    $this.addEventListener("popupClosedEvent", () => {
                        EventVerteiler.broadcastBlockRequestEnded("notLoggedInWarning");
                        $this.removeEventListener("popupClosedEvent");
                    });
                    EventVerteiler.broadcast("displayDialogEvent", {
                        dialog: dialog,
                        callbacks: [
                            () => EventVerteiler.broadcastBlockRequestEnded("notLoggedInWarning"),
                            () => {
                                EventVerteiler.broadcastBlockRequestEnded("notLoggedInWarning");
                                globalsObject.usermanagementConnector.login()
                            }]
                    });
                }
            )

        }, 5);
        this.initEventListeners();
    }

    private initEventListeners() {
        const $this = this;
        this
            .addEventListener("groessenTabelleArrivedEvent", (html) => RahmenTabsDialogDisplayer.displayGroessenTabellenPopup(html, this.localizer))
            .addEventListener("logoConversionRequestedEvent", (data) => this.displayLogoConversionDialog(data.file))
            .addEventListener("loginNeededForLogoConversionEvent", () => this.displayLoginNeeded_ForLogoConversionDialog())
            .addEventListener("logoConversionRequestedWithoutEmailEvent", (data) => this.displayLogoConversionDialogWitEmailInput(data.file))
            .addEventListener("displayLogoConversionMailSentDialogEvent", () => this.displayLogoConversionMailSentDialog())
            .addEventListener("displayLogoConversionMailSentNoEmailDialogEvent", () => this.displayLogoConversionMailSentNoEmailDialog())
            .addEventListener("displayLogoConversionMailErrorHappenedEvent", () => this.displayLogoConversionEmailErrorOccuredDialog())
            .addEventListener("entwurfBasedOnDeprecatedProductEvent", (data) => this.displayDiscardedProductDialog(data.newProduct, data.newAuwiProdukt))
            .addEventListener("displayCustomDialogEvent", (data) => RahmenTabsDialogDisplayer.displayUserInteractionDialog(data.cssClass, data.title, data.message, data.buttons))
            .addEventListener("displayDialogEvent", (data) => RahmenTabsDialogDisplayer.displayDialogEventHandler(data))
            .addEventListener("selObInSperrbezirkEvent", () => this.displaySperrbezirkHint())
            .addEventListener("selObEnteringIllegalCollisionEvent", () => this.displayIllegalCollisionHint())
            .addEventListener("displayHintEvent", (data) => typeof (data.message) !== "undefined" ? this.displayHint(data) : this.displayHint($this.localizer.translate(data)))
            .addEventListener("displaySizeHintEvent", (data) => this.displaySizeHint(data))
            .addEventListener("DISPLAY_ORDERDATE_EXPLANATIONEvent", () => RahmenTabsDialogDisplayer.displayDialogEventHandler({dialog: "BESTELLDATUM_INFO"}))
            .addEventListener("DisplayPDFShareDialogEvent", (link) => this.displayPDFShareResultDialog(link))
            .addEventListener("displayNotLoggedInWarningEvent", (dialog = "warningNotLoggedIn") => this.notLoggedInWarner.execute(dialog))
        ;
    }

    static displayDialogEventHandler(data) {
        if (typeof (data.callbacks) === "undefined") {
            data.callbacks = [];
        }
        if (typeof (data.messageAddition) === "undefined") {
            data.messageAddition = "";
        }

        const container = $("#userInteractionPopup");
        PopupTools.displayDialogEventHandler(container, data.dialog, data.messageAddition, data.callbacks);
    }

    static displayUserInteractionDialog(cssClass, title, message, buttons: PopupButton[] | null = null) {
        PopupTools.displayUserInteractionDialog($("#userInteractionPopup"), cssClass, title, message, buttons);
    }

    displayDiscardedProductDialog(newInternatializedProdukt: string, newAuwiProdukt: string) {
        const p = HTMLPrinter;
        if (newInternatializedProdukt === "") {
            return;
        }
        let okCallback = () => $(".produktpopup-opener").click();
        const newAuswahlProdukt = globalsObject.productController.produkte.getAuswahlProdukte().find(p => p.AuwiProdukt === newAuwiProdukt);
        if (newAuswahlProdukt !== undefined) {
            // @ts-ignore
            okCallback = ()=> Produktwechsel.productChosen(newAuswahlProdukt.Produkt);
        }
        const callbacks = [noop, okCallback];
        const dialog = PopupTools.constructDialogboxDataObject("deprecatedProduct", "", callbacks) as DIALOGDEFINITION;

        dialog.message = dialog.message.replace("__replacedBy__", newInternatializedProdukt === "" ? "" : p.strong(p.quote(newInternatializedProdukt)));
        if (newAuswahlProdukt !== undefined) {
            dialog.buttons[1].text = this.localizer.translate("km_changeToProduct").replace("__target__", newInternatializedProdukt);
        }
        RahmenTabsDialogDisplayer.displayUserInteractionDialog(dialog.cssClass, dialog.title, dialog.message, dialog.buttons);
    }


    /**
     * @param {{message, type, id}|string} data
     */
    displayHint(data) {

        let message, type, id;

        if (data.message) {
            message = data.message;
            type = data.type;
            id = data.id;
        } else {
            message = data;
        }
        EventVerteiler.broadcast(HINTBOXEVENTNAMES.SHOWHINT, {message: message, type: type, id: id});
    }

    displaySperrbezirkHint() {
        this.displayHint({
            message: this.localizer.translate("konf_objectInSperrbezirk", "Achtung, durch dieses Objekt wird eine Naht laufen!"),
            type: "warning",
            id: CONSTANTS.WARNING_SPERRBEZIRK
        });
    }

    displayIllegalCollisionHint() {
        this.displayHint({
            message: this.localizer.translate("konf_illegalCollission", "In diesem Bereich kann kein Objekt plaziert werden!"),
            type: "warning",
            id: CONSTANTS.WARNING_ILLEGAL_COLLISION
        });
    }

    displaySizeHint(data: { x, y, displayDPI, dpi, dpiWarning }) {
        const p = HTMLPrinter;
        if (isNaN(data.x) || isNaN(data.y)) {
            return;
        }
        let message = p.sentence(
            this.localizer.translate("konf_caSizeInCm", "ungefähre Größe in cm:"),
            p.br,
            data.x,
            "x",
            data.y,
            "cm"
        );
        if (data.displayDPI) {
            message += p.sentence(p.br, data.dpi.toFixed(0), "dpi");
        }
        if (data.dpiWarning === true) {
            message += [
                p.br,
                p.br,
                this.localizer.translate("konf_dpiWarning", "Achtung, die Auflösung dieses Logos ist für diese Größe zu gering!")
            ].join("\n");
        }
        this.displayHint({
            message: message,
            type: data.dpiWarning ? "warning" : "info"
        });
    }

    static displayGroessenTabellenPopup(tabellenHTML, localizer: LokalisierungsProvider) {
        RahmenTabsDialogDisplayer.displayUserInteractionDialog("sizesTable", localizer.translate("konf_sizesTable", "Größentabelle"), tabellenHTML);
        let linkText = localizer.translate("konf_sizesLinkToWebsite", "");
        const $sizesLinkDomElement = $("#sizesLink");
        linkText = linkText.replace("INSERTLINK", $sizesLinkDomElement.html());
        $sizesLinkDomElement.replaceWith(linkText);
    }

    displayLogoConversionDialog(file: File) {
        $(".logoConversionHideable").hide();
        PopupTools.openPopup(POPUPS.LOGO_CONVERSION);
        $("#logoConversionSendButton").off().click(function () {
            const $logoConversionname = $("#logoConversionname");
            const name = $logoConversionname.val();
            if (name === "") {
                $logoConversionname.addClass("error");
                return;
            }
            $logoConversionname.removeClass("error");

            EventVerteiler.broadcast(
                "sendLogoForConversionEvent",
                {
                    file: file,
                    email: globalsObject.controller.model.user.getEmail(),
                    name: name,
                    comment: RahmenTabsStaticFunctions.getLogoConversionComment()
                }
            );
            PopupTools.close();
        });
    }

    displayLogoConversionDialogWitEmailInput(file: File) {
        const $this = this;
        $(".logoConversionHideable").show();

        const openLogoConversionDialog = () => PopupTools.openPopup(POPUPS.LOGO_CONVERSION);
        openLogoConversionDialog();


        $("#logoConversionSendButton").off().click(function (event) {
            const emailInputField = $("#logoConversionEmail");
            const email = emailInputField.val() as string;
            const nameField = $("#logoConversionname");
            if (email === "") {
                emailInputField.addClass("error");
                handleError(
                    "normal",
                    "Rahmentabs",
                    $this.localizer.translate("konf_logoConversionEmailDescription", "Bitte geben Sie Ihre Email an, " +
                        "damit wir Sie benachrichtigen können, wenn wir Ihraa Logo in den Account geladen haben"),
                    openLogoConversionDialog
                );
                event.preventDefault();
                return false;
            }
            if (nameField.val() === "") {
                nameField.addClass("error");
                return false;
            }
            emailInputField.removeClass("error");
            nameField.removeClass("error");

            EventVerteiler.broadcast(
                "sendLogoForConversionEvent",
                {
                    file: file,
                    email: email,
                    name: nameField.val(),
                    comment: RahmenTabsStaticFunctions.getLogoConversionComment()
                }
            );
            PopupTools.close();
            return true;
        });
    }


    displayLoginNeeded_ForLogoConversionDialog() {
        const p = HTMLPrinter;
        const message = [
            p.h3(this.localizer.translate("konf_formatNotNativelySupported", "Dieses Dateiformat wird nicht nativ von unserem Konfigurator unterstützt.")),
            p.p(this.localizer.translate("konf_sendLogoToOwayoDescription", "Wenn Sie wollen, können Sie die Datei an einen unserer Mitarbeiter schicken, " +
                "dieser wird Ihnen das Logo in Ihren Account laden.")),
            p.p(this.localizer.translate("konf_loginAndRestartUpload", "Bitte loggen Sie sich ein oder Erstellen Sie einen neuen Account und starten Sie den Upload erneut"))
        ].join("\n");

        RahmenTabsDialogDisplayer.displayUserInteractionDialog(
            "logo-conversion-dialog",
            this.localizer.translate("konf_logoConversion_caption", "Logo Umwandeln"),
            message,
            [
                new PopupButton(this.localizer.translate("konf_Cancel", "Cancel")),
                new PopupButton(this.localizer.translate("konf_Login", "Login"), () => globalsObject.usermanagementConnector.login())
            ]
        );
        EventVerteiler.broadcast("resetFileUploadEvent");
    }

    displayLogoConversionMailSentDialog() {
        RahmenTabsDialogDisplayer.displayUserInteractionDialog(
            "notice mailSent",
            this.localizer.translate("konf_mailSentCaption", "Email versendet"),
            this.localizer.translate(
                "konf_logoConversionMailSent_emailPresent",
                "Vielen Dank! Ihre Datei wurde an owayo übermittelt. Wir informieren Sie per E-mail sobald das Logo in Ihrem Account verfügbar ist"
            )
        );
    }

    displayLogoConversionMailSentNoEmailDialog() {
        RahmenTabsDialogDisplayer.displayUserInteractionDialog(
            "notice mailSent",
            this.localizer.translate("konf_mailSentCaption", "Email versendet"),
            this.localizer.translate(
                "konf_logoConversionMailSent_emailMissing",
                "Vielen Dank! Ihre Datei wurde an owayo übermittelt. Wir werden Ihnen so bald wie möglich die Datei in Ihren Account laden."
            )
        );
    }

    displayLogoConversionEmailErrorOccuredDialog() {
        RahmenTabsDialogDisplayer.displayUserInteractionDialog(
            "warning mailSent",
            this.localizer.translate("konf_error_sendingEmail", "Verzeihung, die E-Mail konnte nicht versendet werden."),
            this.localizer.translate(
                "konf_logoConversionMailErrorMessage",
                "Leider ist ein Fehler beim Versenden Ihres Logos aufgetreten. Bitte senden Sie uns die Datei doch <a href='mailto:info@owayo.com'>direkt</a> zu!"
            )
        );
    }

    displayPDFShareResultDialog(linkURL) {
        const callback = function () {
            window.open(linkURL, "_blank");
            $("#pdfready").parent(".white-popup").css("display", "none");
        };
        RahmenTabsDialogDisplayer.displayDialogEventHandler({dialog: "PDFReady", callbacks: [callback]});
    }
}
